<template>    
    <MyHeader></MyHeader>
    <MyMap ref="myMap"></MyMap>
  </template>
  
  <script> 
  import MyMap from './components/MyMap.vue';
  import MyHeader from './components/Header.vue';
  
  export default {
    name: 'App',
    components: {
      // HelloWorld,
      MyHeader,
      MyMap
    },
    mounted(){
      this.$nextTick(() => {
        this.$refs.myMap.init();
        });
    }
  }
  </script>
  
  <style>
  #app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    /* margin-top: 60px; */
  }
  </style>
  